import React from "react";

const Transactions = ({ color: _color }: { color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 20 20"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.1875 7.25C6.1875 5.6967 7.4467 4.4375 9 4.4375C10.5533 4.4375 11.8125 5.6967 11.8125 7.25C11.8125 8.8033 10.5533 10.0625 9 10.0625C7.4467 10.0625 6.1875 8.8033 6.1875 7.25ZM9 5.5625C8.06802 5.5625 7.3125 6.31802 7.3125 7.25C7.3125 8.18198 8.06802 8.9375 9 8.9375C9.93198 8.9375 10.6875 8.18198 10.6875 7.25C10.6875 6.31802 9.93198 5.5625 9 5.5625Z"
        fill="#FFFF00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.09231 6.59543C4.29763 4.10452 6.37917 2.1875 8.87852 2.1875H9.12149C11.6208 2.1875 13.7024 4.10452 13.9077 6.59543C14.0178 7.93063 13.6053 9.25644 12.7573 10.2936L10.0612 13.5908C9.51271 14.2616 8.48729 14.2616 7.93884 13.5908L5.24274 10.2936C4.39468 9.25644 3.98225 7.93063 4.09231 6.59543ZM8.87852 3.3125C6.96465 3.3125 5.37073 4.78045 5.21351 6.68785C5.12739 7.73257 5.4501 8.76994 6.11366 9.58146L8.80976 12.8787C8.90808 12.999 9.09192 12.999 9.19025 12.8787L11.8863 9.58146C12.5499 8.76994 12.8726 7.73257 12.7865 6.68785C12.6293 4.78045 11.0354 3.3125 9.12149 3.3125H8.87852Z"
        fill="#FFFF00"
      />
      <path
        d="M5.75312 12.7516C5.89205 12.4737 5.77942 12.1358 5.50156 11.9969C5.2237 11.858 4.88582 11.9706 4.74689 12.2484L3.24689 15.2484C3.1597 15.4228 3.16902 15.6299 3.27151 15.7957C3.374 15.9616 3.55505 16.0625 3.75 16.0625H14.25C14.445 16.0625 14.626 15.9616 14.7285 15.7957C14.831 15.6299 14.8403 15.4228 14.7531 15.2484L13.2531 12.2484C13.1142 11.9706 12.7763 11.858 12.4984 11.9969C12.2206 12.1358 12.108 12.4737 12.2469 12.7516L13.3399 14.9375H4.66014L5.75312 12.7516Z"
        fill="#FFFF00"
      />
    </svg>
  );
};

export default Transactions;
